module.exports = __webpack_public_path__ + "img/text.ee0d14fb.png";